export default __webpack_public_path__ + "static/media/computer_courseSmall.6e63abbb.jpg";